import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './ethnic-group.reducer';

export const EthnicGroupDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const ethnicGroupEntity = useAppSelector(state => state.ethnicGroup.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="ethnicGroupDetailsHeading">
          <Translate contentKey="apiLocationApp.ethnicGroup.detail.title">EthnicGroup</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{ethnicGroupEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.ethnicGroup.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{ethnicGroupEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.ethnicGroup.date">Date</Translate>
            </span>
          </dt>
          <dd>{ethnicGroupEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.ethnicGroup.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{ethnicGroupEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.ethnicGroup.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{ethnicGroupEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllUsualResidents">
              <Translate contentKey="apiLocationApp.ethnicGroup.totalAllUsualResidents">Total All Usual Residents</Translate>
            </span>
          </dt>
          <dd>{ethnicGroupEntity.totalAllUsualResidents}</dd>
          <dt>
            <span id="asian">
              <Translate contentKey="apiLocationApp.ethnicGroup.asian">Asian</Translate>
            </span>
          </dt>
          <dd>{ethnicGroupEntity.asian}</dd>
          <dt>
            <span id="black">
              <Translate contentKey="apiLocationApp.ethnicGroup.black">Black</Translate>
            </span>
          </dt>
          <dd>{ethnicGroupEntity.black}</dd>
          <dt>
            <span id="mixed">
              <Translate contentKey="apiLocationApp.ethnicGroup.mixed">Mixed</Translate>
            </span>
          </dt>
          <dd>{ethnicGroupEntity.mixed}</dd>
          <dt>
            <span id="white">
              <Translate contentKey="apiLocationApp.ethnicGroup.white">White</Translate>
            </span>
          </dt>
          <dd>{ethnicGroupEntity.white}</dd>
          <dt>
            <span id="otherEthnicGroup">
              <Translate contentKey="apiLocationApp.ethnicGroup.otherEthnicGroup">Other Ethnic Group</Translate>
            </span>
          </dt>
          <dd>{ethnicGroupEntity.otherEthnicGroup}</dd>
        </dl>
        <Button tag={Link} to="/ethnic-group" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/ethnic-group/${ethnicGroupEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default EthnicGroupDetail;
